/**
 * Ob das Suchfenster offen ist (F-18) - ein einziges fuer die ganze App,
 * geoeffnet ueber Strg+K, den Such-Knopf oder ein Schlagwort (`#wort`).
 */
import { create } from 'zustand';

interface SucheState {
  offen: boolean;
  /** Womit die Suche startet, z. B. `#haushalt` nach Klick auf ein Schlagwort. */
  start: string;
  oeffnen: (start?: string) => void;
  schliessen: () => void;
}

export const useSuche = create<SucheState>()((set) => ({
  offen: false,
  start: '',
  oeffnen: (start = '') => set({ offen: true, start }),
  schliessen: () => set({ offen: false, start: '' }),
}));
